const main = () => {
    document.querySelectorAll('.c-others-toc').forEach((toc) => {
        if (toc.hasAttribute('data-static')) {
            return;
        }

        const header = toc.querySelector('.c-others-toc__header');
        const body = toc.querySelector('.c-others-toc__body');
        if (!header || !body) return;

        if (toc.hasAttribute('data-open')) {
            body.style.maxHeight = body.scrollHeight + 'px';
        }

        header.addEventListener('click', () => {
            const isOpen = toc.hasAttribute('data-open');
            if (isOpen) {
                body.style.maxHeight = body.scrollHeight + 'px';
                requestAnimationFrame(() => {
                    body.style.maxHeight = '0';
                });
                toc.removeAttribute('data-open');
                header.setAttribute('aria-expanded', 'false');
            } else {
                toc.setAttribute('data-open', '');
                header.setAttribute('aria-expanded', 'true');
                body.style.maxHeight = body.scrollHeight + 'px';
                body.addEventListener('transitionend', function handler() {
                    if (toc.hasAttribute('data-open')) {
                        body.style.maxHeight = 'none';
                    }
                    body.removeEventListener('transitionend', handler);
                });
            }
        });
    });
};

export default main;
